export function formatCurrency(value: number) {
  return new Intl.NumberFormat("en-GH", {
    style: "currency",
    currency: "GHS",
    maximumFractionDigits: 2,
  }).format(value);
}

export function formatEventDate(date: string, time?: string) {
  const dateValue = new Date(`${date}${time ? `T${time}` : "T12:00"}`);

  return new Intl.DateTimeFormat("en-US", {
    weekday: "short",
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: time ? "numeric" : undefined,
    minute: time ? "2-digit" : undefined,
  }).format(dateValue);
}

export function formatCompactDate(date: string) {
  return new Intl.DateTimeFormat("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  }).format(new Date(date));
}

export function formatDateTime(value: string) {
  return new Intl.DateTimeFormat("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
  }).format(new Date(value));
}

export function formatRelativeDate(date: string) {
  const value = new Date(date).getTime() - Date.now();
  const days = Math.round(value / (1000 * 60 * 60 * 24));

  if (Math.abs(days) < 1) {
    return "Today";
  }

  if (days === 1) {
    return "Tomorrow";
  }

  if (days === -1) {
    return "Yesterday";
  }

  return `${Math.abs(days)} day${Math.abs(days) === 1 ? "" : "s"} ${days > 0 ? "away" : "ago"}`;
}
